import { KeypadContext } from '@3plearning/question-components-library';
import { Box, Button, Img } from '@chakra-ui/react';
import { t } from '@lingui/macro';
import React, { useContext } from 'react';

import { useLocalisation } from '../../helpers/i18n/use-localisation';
import keypadIcon from '../../assets/images/keypad.svg';

export const Keypad = () => {
  const { i18n } = useLocalisation();
  const {
    showKeypad, setShowKeypad, showKeypadBtn, isKeypadBtnDisabled
  } = useContext(KeypadContext);
  const toggleKeypad = (event) => {
    event.preventDefault();
    setShowKeypad(!showKeypad);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      toggleKeypad(event);
    }
  };

  if (!showKeypadBtn) {
    return null;
  }

  return (
    <Button
      w={'42px'}
      h={'42px'}
      left={0}
      bottom={'40px'}
      transform={'translate(-50%, 0)'}
      zIndex={1}
      position={'absolute'}
      variant={'read-aloud'}
      title={i18n._(t`Toggles keypad`)}
      aria-label={i18n._(t`Toggles keypad`)}
      onMouseDown={toggleKeypad}
      onKeyDown={handleKeyDown}
      isDisabled={isKeypadBtnDisabled}
      isActive={showKeypad && !isKeypadBtnDisabled}
      _active={{ bg: 'primary.300' }}
      _disabled={{
        _hover: { bg: 'neutral.100' },
        bg: 'neutral.100',
        borderColor: 'neutral.200',
        cursor: 'not-allowed'
      }}
    >
      <Box as={'span'} borderRadius={'4px'} bg={'white'}><Img src={keypadIcon} mr={'-1px'} my={'-1px'} /></Box>
    </Button>
  );
};
